import * as firestore from 'firebase/firestore';
import { DateTime } from 'luxon';
import { PassportRequest } from '../types/PassportRequest';

export default {
  toFirestore(passportRequest: PassportRequest): firestore.DocumentData {
    return passportRequest;
  },
  fromFirestore(
    snapshot: firestore.QueryDocumentSnapshot
  ): PassportRequest {
    const data = snapshot.data()!;
    return {
      id: data.id,
      uid: data.uid,
      idNumber: data.idNumber,
      name: data.name,
      reason: data.reason,
      dateRequested: data.dateRequested,
      dateResponded: data.dateResponded,
      dateReturned: data.dateReturned,
      type: data.type,
      status: data.status,
      lastUpdate: DateTime.fromJSDate((data.lastUpdate as firestore.Timestamp).toDate()).toISO()
    };
  }
};
